import { Box, Typography, styled } from "@mui/material";
import { Fragment } from "react";

import { IconChevronRight } from "@/assets/icons";
import { background, divider, icon, text } from "@/theme/colors";

/** 適用中のフロー — read-only pill chain (下書き → … → 完了). Shared by edit & detail. */
export const FlowStepsBox = ({ steps }: { steps: string[] }) => (
  <FlowBox>
    {steps.map((step, index) => (
      <Fragment key={step}>
        {index > 0 && <IconChevronRight width={16} height={16} color={icon.default} style={{ flexShrink: 0 }} />}
        <FlowChip>
          <Typography variant="cap12" color={text.primary}>
            {step}
          </Typography>
        </FlowChip>
      </Fragment>
    ))}
  </FlowBox>
);

const FlowBox = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
  border: 1px solid ${divider.middle};
  border-radius: 8px;
  background: ${background.primary};
  padding: 16px;
`;

/** Each chip takes an equal share of the row so the chain spans the full width. */
const FlowChip = styled(Box)`
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${divider.high};
  border-radius: 16px;
  background: ${background.white};
  padding: 4px 8px;
  white-space: nowrap;
`;
